import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IBehaelter } from '../_interfaces/behaelter';
import { IPagination } from '../_interfaces/pagination';

import { HttpClient } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppconfigService } from '../_services/appconfig.service';

import { IHersteller } from '../_interfaces/hersteller';
import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';
import { HerstellerService } from './hersteller.service';


@Injectable()
export class BehaelterService extends CRUDBasicService {

  constructor(
    protected httpClient: HttpClient,
    protected config: AppconfigService,
    private herstellerService: HerstellerService
  ) {
    super(httpClient, config);
  }

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'interneBehaelterNummer', type: 'string'},
    {name: 'behaelterNummer', type: 'string'},
    {name: 'verfuegbarkeitsstatus', type: 'string'},
    {name: 'behaeltervolumen', type: 'string'}, // Liter
    {name: 'hersteller', type: 'string'},
    {name: 'baujahr', type: /*'string'*/'DateTimeOffset'},
    {name: 'tankfarbe', type: 'string'},
    {name: 'lagerungsart', type: 'string'},
    {name: 'anlagenart', type: 'string'},
    {name: 'tUEVDatum', type: 'DateTimeOffset'},
    {name: 'letzteBewegung', type: 'DateTimeOffset'}
  ];

  getBehaelterCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ behaelter: IBehaelter[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'behaelter?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { behaelter: <IBehaelter[]>response.body, 
            pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length)
          };
        }), catchError(this.handleError))
  }

  /*getBehaelterCollectionForAutoComplete(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ behaelter: IBehaelter[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'behaelter?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          console.log("BehaelterService.getBehaelterCollectionForAutoComplete() response:", response);
          (response.body as IBehaelter[]).forEach(behaelter => {
            //behaelter.summary = behaelter.behaelterNummer + " " + behaelter.hersteller + " " + behaelter.baujahr; // kommt warum auch immer nicht aus der API
            behaelter.summary = this.buildSummary(behaelter, null);
          });
          return { behaelter: <IBehaelter[]>response.body, 
            pagination: this.getDummyPagination((<any[]>response.body).length) // <IPagination>JSON.parse(response.headers.get('x-pagination'))
          };
        }), catchError(this.handleError))
  }*/

  getBehaelterCollectionForAutoComplete(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ behaelter: IBehaelter[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'behaelter?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        switchMap((response) => {
          const behaelterList = <IBehaelter[]>response.body;
          const pagination = this.getDummyPagination(behaelterList.length);

          return this.herstellerService.getHerstellerCollection(1, 9999, '').pipe(
            map((herstellerResponse) => {
              behaelterList.forEach(behaelter => {
                const hersteller = herstellerResponse.hersteller.find(h => h.hersteller === behaelter.hersteller) ?? null;
                behaelter.summary = this.buildSummary(behaelter, hersteller);
              });

              return { behaelter: behaelterList, pagination };
            })
          );
        }),
        catchError(this.handleError)
      );
  }
  
  getBehaelter(id: number): Observable<IBehaelter> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeAnstrich());
      //   observer.complete();
      // })
      console.log("BehaelterService.getBehaelter() id === 0. return empty object.");
      return of(this.initializeBehaelter());
    }

    return this.httpClient.get<IBehaelter>(this.apiBaseUrl + 'behaelter/?behaelter=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => 
        //response
        {
          return response[0];
        }
      ), catchError(this.handleError));
  }

  getBehaelterForAutoComplete(id: number): Observable<IBehaelter> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeAnstrich());
      //   observer.complete();
      // })
      console.log("BehaelterService.getBehaelterForAutoComplete() id === 0. return empty object.");
      return of(this.initializeBehaelter());
    }

    return this.httpClient.get<IBehaelter>(this.apiBaseUrl + 'behaelter/?behaelter=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        switchMap((response) => {
          const behaelter = <IBehaelter>response[0];
          return this.herstellerService.getHerstellerCollection(1, 9999, '').pipe(
            map((herstellerResponse) => {
              const hersteller = herstellerResponse.hersteller.find(h => h.hersteller === behaelter.hersteller) ?? null;
              behaelter.summary = this.buildSummary(behaelter, hersteller);
              return behaelter;
            })
          );
        }),
        catchError(this.handleError)
      );
  }

  buildSummary(item: IBehaelter, hersteller?: IHersteller) {
    let summary = item.behaelterNummer + " " + (hersteller != null ? hersteller.bezeichnung : item.hersteller) + " ";
    const input = "2019-04-15T00:00:00+00:00";
    let date = new Date(item.baujahr);
    let month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() ist 0-basiert
    let year = date.getFullYear();
    let MY = `${month}/${year}`;

    summary += MY;
    return summary;
  }

  initializeBehaelter(): IBehaelter {
    return {
      id: 0,
      interneBehaelterNummer: '',
      behaelterNummer: '',
      verfuegbarkeitsstatus: '',
      behaeltervolumen: '', // Liter
      hersteller: '',
      baujahr: null,
      tankfarbe: '',
      lagerungsart: '',
      anlagenart: '',
      tUEVDatum: null,
      letzteBewegung: null,
      nanolack: false,
      teilUeberfahrbar: false,
      mitASS: false,
      fluessigentnahmeFlansch: false,
      armaturenMittig: false,
      armaturenverlaengerungImDomschacht: false,
      summary: ''
    };
  }
}
